import React from 'react'
import ContactHero from '../components/contact/ContactHero'
function Contact() {
    return (
        <div>
            <ContactHero/>
        </div>
    )
}

export default Contact
